import React from "react";
import { useFieldWrapper } from "../hooks";
import { FormFieldDateTimePicker } from "./FormFieldDateTimePicker";
import { TimeComponent, TimeComponentProps } from "./TimeComponent";

export const TimeComponentWrapper = (props: TimeComponentProps) => {
	const WrappedComponent = useFieldWrapper(TimeComponent, FormFieldDateTimePicker);
	return <WrappedComponent {...props} />;
};